import React,{Component} from "react";
import {connect} from 'react-redux';
import {setBannerStatus,deleteBanner,getAllBanners,emptyBanner} from '../../Actions/BannerAction'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Redirect} from 'react-router-dom'
import { Confirm } from 'semantic-ui-react'
/* Routes */
import { ALL_BANNERS } from '../../routes';

class DeleteBanner extends Component
{
    state={open:false}
    open=()=>this.setState({open:true})
    close =()=>this.setState({open:false})

    removeBanner(id)
    {
        this.props.deleteBanner(id);
    }


    handleSubmit =(e)=>
    {
        const {id} = this.props;
        this.removeBanner(id);
        this.close();
    }

    render ()
    {
        const {banner_deleted_successfully,error_deleting_banner} = this.props;
        if (banner_deleted_successfully===false)
        {
            alert ("error deleting banner"+ error_deleting_banner);
            this.props.emptyBanner();
        }
        else if (banner_deleted_successfully===true)
        {
            alert("banner deleted successfully");
            this.props.emptyBanner();
            this.props.getAllBanners();
            return (<Redirect to={ALL_BANNERS}></Redirect>)
        }
        return (<div >
            <button className="seriesCardButtons"  onClick={this.open}>
                 
                        <FontAwesomeIcon icon="trash-alt" />
                  
                </button>
                <Confirm id="modal"
                open={this.state.open}
                onCancel={this.close}
                content='Are You Sure To Delete This Banner ? '
                onConfirm={this.handleSubmit} />
            </div>)

    }

}
const mapStateToProps = state =>
({
    banner_deleted_successfully:state.banners.banner_deleted_successfully,
    error_deleting_banner:state.banners.error_deleting_banner,

})
export default connect (mapStateToProps,{setBannerStatus,deleteBanner,getAllBanners,emptyBanner}) (DeleteBanner)
